<template>
	<router-link :to="item.has_story ? `/brandDetail/${item.slug}` : `/product?brand=${item.slug}`"
		class="hot-sale-item" :style="'background-color: #'+item.color+';'">
		<div class="pic">
			<img :src="item.pic.data.attributes.url"
				:alt="'亚洲食品批发-美国华源食品集团, OCM Foods Group  - Asian food wholesale' + item.brand + ', ' + item.name">
		</div>
		<article class="txt-box">
			<h4>
				<router-link
					:to="item.has_story ? `/brandDetail/${item.slug}` : `/product?brand=${item.slug}`"
					:style="lang === 'en' ? {fontFamily: 'Arial'} : {}">{{item.brand}}</router-link>
			</h4>
			<p>{{item.name}}</p>
		</article>
	</router-link>
</template>

<script>
export default {
	name: "hotSaleItem",
	props: {
		item: [Object],
		lang: [String]
	}
}
</script>

<style scoped lang="scss">
.hot-sale-item {
	border-radius: 10px;
	margin: 0 10px 20px;
	flex: 1 0 280px;
	max-height: 400px;
	position: relative;
	.pic {
		img {
			display: block;
			width: 100%;
		}
	}
	.txt-box {
		position: absolute;
		min-width: 192px;
		max-width: calc(100% - 24px);
		bottom: 24px;
		left: 24px;
		z-index: 2;
		padding: 8px 20px;
		background: rgba(247, 244, 243, 0.95);
		border-radius: 10px;
		h4 {
			@extend .title1;
			font-size: 28px;
			font-weight: 400;
			position: relative;
			margin-bottom: 4px;
			a {
				-webkit-transition: all 0.3s;
				-moz-transition: all 0.3s;
				-ms-transition: all 0.3s;
				-o-transition: all 0.3s;
				transition: all 0.3s;
			}
			a:hover {
				color: $activeColor;
			}
		}
		h4:after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			width: 20px;
			height: 1px;
			background-color: #dddbcb;
		}
		p {
			@extend .regular-14px;
		}
	}
}
.hot-sale-item:nth-child(5) {
	flex: 0 0 480px;
	.pic {
		height: 100%;
		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
}
.hot-sale-item:last-child {
	.pic {
		position: absolute;
		right: 24px;
		height: 100%;
		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
}

@media only screen and (max-width: 959px) {
	.hot-sale-item:nth-child(5) {
		flex: 1 0 280px;
	}
	.hot-sale-item:last-child {
		.pic {
			position: static;
		}
	}
}
</style>
